import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { TokenRefresh } from "../../app/generated-axios-client/myModel/token-refresh";
import type { TokenObtainPair } from "../../app/generated-axios-client";

export interface TokenState {
  token: TokenRefresh | null;
}

const accessToken = localStorage.getItem("access");
const refreshToken = localStorage.getItem("refresh");
const initialState: TokenState = {
  token:
    accessToken && refreshToken
      ? {
          access: accessToken,
          refresh: refreshToken,
        }
      : null,
};

export const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    addToken: (state, action: PayloadAction<TokenObtainPair>) => {
      state.token = action.payload;
    },
    doLogout: (state) => {
      state.token = null;
    },
  },
});

export const tokenActions = tokenSlice.actions;

export default tokenSlice.reducer;
